module.exports = __webpack_public_path__ + "static/2-a0b3d91ef4ee6ce94078626b524c79d4.jpeg";